import { SHARED } from "@apps/manage-app/src/app/shared/shared";
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostBinding, HostListener, Input, ViewChild } from "@angular/core";
import { Enums } from "@apps/manage-app/src/enums";
import { DevicesIphone14ProComponent } from "./iphone-14-pro/iphone-14-pro.component";
import { PORTAL_VIEWER_URL_CHANGE_EVENT } from "@shared/constants";
import { NgIconComponent, provideIcons } from "@ng-icons/core";
import { heroBugAnt } from "@ng-icons/heroicons/outline";

@Component({
  selector: "dentr-devices",
  templateUrl: "./devices.component.html",
  host: { class: "origin-top-left block" },
  standalone: true,
  imports: [SHARED, DevicesIphone14ProComponent, NgIconComponent],
  providers: [
    provideIcons({
      heroBugAnt,
    }),
  ],
})
export class DevicesComponent implements AfterViewInit {
  private _url: string;
  private _debugInfo: Record<string, string>;
  @HostListener("window:message", ["$event"]) onMessage(event) {
    if (event.data?.id === PORTAL_VIEWER_URL_CHANGE_EVENT && event.data?.url) {
      const queryString = event.data.url.split("?")[1] || "";
      const urlParams = new URLSearchParams(queryString);
      const queryParams: Record<string, string> = {};

      urlParams.forEach((value, key) => {
        queryParams[key] = value;
      });

      this._debugInfo = {
        url: event.data.url.split("?")[0],
        ...queryParams,
      };
    }
  }

  @ViewChild("content") public content: ElementRef;
  public DEVICES = Enums.DEVICES;
  public hasContent: boolean;
  public video = {
    src: "",
    poster: "",
    type: "mp4",
  };

  @Input() device: Enums.DEVICES;
  @Input() size?: Enums.E_DEVICES_SIZE = Enums.E_DEVICES_SIZE.MD;
  @Input() showVideo?: boolean = false;

  @HostBinding("class") get scale() {
    switch (this.size) {
      case Enums.E_DEVICES_SIZE.LG:
        return "scale-100";
      case Enums.E_DEVICES_SIZE.SM:
        return "scale-50";
      default:
        return "scale-75";
    }
  }

  constructor(private _changeDetectorRef: ChangeDetectorRef) {}

  public set debugInfo(debugInfo: Record<string, string>) {
    this._debugInfo = debugInfo;
  }

  public get debugInfo(): Record<string, string> {
    return this._debugInfo;
  }

  public get hasDebugInfo(): boolean {
    return this.debugInfo ? Object.keys(this.debugInfo).length > 0 : false;
  }

  public ngAfterViewInit() {
    this.hasContent = this.content?.nativeElement.getElementsByClassName("device-content")[0]?.childNodes.length > 0;
    this.prepareVideo();
    this._changeDetectorRef.detectChanges();
  }

  public ngOnChanges(_) {
    this.prepareVideo();
  }

  public prepareVideo() {
    const video = this.content?.nativeElement?.querySelector("video");
    if (!video) return;

    if (!this.hasContent || this.showVideo) {
      this._generateContentPlaceholder();
      video.muted = true;
      video.play();
    } else if (video && video.stop) {
      video.stop();
    }
  }

  private _generateContentPlaceholder() {
    switch (this.device) {
      case Enums.DEVICES.IPHONE_14_PRO:
        this.video.src = "iphone-bg.mp4";
        this.video.poster = "iphone-bg-poster.png";
    }
  }
}
